import type { CreateWorkOrderInput, Currency, WorkOrderSeverity, WorkOrderSource } from '@chukua/common';
import { parseMoneyAmount } from '../../../../../shared/policies/parse-money-amount';

export interface RaiseWorkOrderFormValues {
  truckId?: string;
  source?: WorkOrderSource;
  severity?: WorkOrderSeverity;
  title: string;
  description: string;
  sourceRef: string;
  /** Major units as typed ("45,000.50"); converted to minor units when sent. */
  estimate: string;
  currency: Currency;
}

export function blankRaiseForm(): RaiseWorkOrderFormValues {
  return { title: '', description: '', sourceRef: '', estimate: '', currency: 'KES' };
}

/** The request body, or the first field-level reason it cannot be built yet. The estimate is parsed as a decimal string, never as a float. */
export function toRaiseInput(values: RaiseWorkOrderFormValues): { ok: true; input: CreateWorkOrderInput } | { ok: false; reason: string } {
  const estimate = parseMoneyAmount(values.estimate, values.currency);
  if (!estimate.ok) return { ok: false, reason: estimate.reason };
  if (!values.truckId || !values.source || !values.severity) return { ok: false, reason: 'Choose the truck, source and severity' };
  return {
    ok: true,
    input: {
      truckId: values.truckId,
      source: values.source,
      severity: values.severity,
      title: values.title.trim(),
      ...(values.description.trim() ? { description: values.description.trim() } : {}),
      ...(values.sourceRef.trim() ? { sourceRef: values.sourceRef.trim() } : {}),
      estimatedCost: { amountMinor: estimate.amountMinor, currency: values.currency },
    },
  };
}
